// extracted by mini-css-extract-plugin
module.exports = {"image":"sb-image_image__fAobC"};